<template>
  <donut-slack-preview :message="message" :hide-name="true" />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { getters } = useStore();
  const props = defineProps({
    points: { type: Number, default: 3 },
  });

  const message = computed(() => `You received *${getters['pointsConfig/pointsPhraseFromConfig'](props)}* `
      + 'from :::@becca::: in :::#shoutouts:::');
</script>
